<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button size="medium" type="primary" @click="jumpToPage('moduleRolePermissionAdd')"
                       v-if="isShowByPermission('/wyms/moduleRolePerm/insertModuleRolePerm')">增加角色权限配置
            </el-button>
            <el-button size="medium" type="danger" @click="batchDeleteHandler" v-if="isShowByPermission('/wyms/moduleRolePerm/deleteModuleRolePerm')">删除</el-button>
            <el-input size="medium" class="search-input search-input--right" placeholder="模块名称模糊或者权限路径URL全匹配或者角色名称模糊"
                      v-model="term" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 220"
                :data="dataList"
                style="width: 100%" border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="模块常量"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.code }}
                    </template>

                </el-table-column>
                <el-table-column
                    label="模块名称"
                    prop="moduleName"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="角色常量"
                    align="center"
                    prop="constantId"
                >
                </el-table-column>
                <el-table-column
                    label="角色名称"
                    align="center"
                    prop="roleName"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text"
                                   v-if="isShowByPermission('/wyms/moduleRolePerm/updateModuleRolePerm')"
                                   @click="jumpToPage('moduleRolePermissionEdit', {id: scope.row.id, moduleId: scope.row.moduleId})">
                            编辑
                        </el-button>
                        <el-button type="text" @click="deleteHandler(scope.row.id)" v-if="isShowByPermission('/wyms/moduleRolePerm/deleteModuleRolePerm')">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        deleteModuleRolePerm,
        queryModuleRolePermList
    } from '@/api/moduleRolePermission';

    export default {
        name: "moduleRolePermissionList",
        data() {
            return {
                term: '',
                dataList: [],
                multipleSelection: [],
            }
        },
        created() {
            this.queryModuleRolePermListFunc()

        },
        mixins: [windowResize, baseMixin],
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.queryModuleRolePermListFunc()
            });
        },
        methods: {
            isShowByPermission,
            getList() {
                this.pagination.pageNo = 1;
                this.queryModuleRolePermListFunc();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.queryModuleRolePermListFunc();
            },
            currentChangeHandler() {
                this.queryModuleRolePermListFunc();
            },
            batchDeleteHandler() {
                console.log(this.multipleSelection)
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的角色');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(ids) {
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteModuleRolePerm({
                        ids
                    })
                        .then(() => {
                            this.queryModuleRolePermListFunc();
                        })
                });
            },
            queryModuleRolePermListFunc() {
                queryModuleRolePermList({
                    term: this.term,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss">
    #moduleAppList {
        padding: 12px;

        .top {
            padding-bottom: 10px
        }

        a {
            color: #409EFF;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleRolePermission/moduleRolePermissionList.vue